import React from 'react';
import {
  FDBox,
  FDSecondaryActionButton,
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import { ClickableTextRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ClickableTextRel';
import useEventTrackingLogEvent, { categories, eventTypes, eventSubTypes } from 'EventTracking/useEventTrackingLogEvent';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useUserContext from 'Context/UserContext';

const RoadmapDeliverableFooterNav = ({
  onNext,
  onPrevious,
  disabled,
  loading,
  primaryActionLabel,
  secondaryActionLabel,
  clickableTextRel = undefined,
  onClickableTextRel = undefined,
}) => {
  const isMobile = useMobileLayout();
  const { isAgent, userResource } = useUserContext();
  const { pageContentResource } = usePageContentContext();
  const { logStandardizedEvent, logStandardizedEventFailureWithError } = useEventTrackingLogEvent();

  const eventProperties = {
    resourceType: pageContentResource?.type(),
    isAgent,
    userId: userResource?.id(),
  };

  const handleOnNext = async () => {
    logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.submitStep, { eventProperties });
    try {
      await onNext();
      logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.success, { eventProperties });
    } catch (e) {
      logStandardizedEventFailureWithError(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.failure, e, { eventProperties });
    }
  };

  const handleOnPrevious = async () => {
    logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.goBack, { eventProperties });
    try {
      await onPrevious();
      logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.success, { eventProperties });
    } catch (e) {
      logStandardizedEventFailureWithError(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.failure, e, { eventProperties });
    }
  };

  const handleOnClickableTextRel = onClickableTextRel ? async () => {
    // Safety check to make sure that the onClickableTextRel is defined before calling it
    if (!onClickableTextRel) return;
    logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickClickableText, eventSubTypes.clickLink, { eventProperties });
    try {
      await onClickableTextRel();
      logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickClickableText, eventSubTypes.success, { eventProperties });
    } catch (e) {
      logStandardizedEventFailureWithError(categories.roadmapDeliverable, eventTypes.clickClickableText, eventSubTypes.failure, e, { eventProperties });
    }
  } : undefined;

  return (
    <FDBox paddingY={5} width={'100%'}>
      {/* Our FDStack does not support column-reverse, so we have to use a styled div to achieve the same effect */}
      <FDStack direction={'column'} spacing={2} alignItems={'center'}>
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column-reverse' : 'row',
            gap: '16px',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            flexWrap: 'wrap',
          }}
        >
          {onPrevious ? (
            <FDBox width={isMobile ? '100%' : undefined}>
              <FDSecondaryActionButton
                label={secondaryActionLabel}
                onClick={handleOnPrevious}
                loading={loading}
                isFullWidth
                {...dataAttrs('back-btn')}
              />
            </FDBox>
          ) : null}
          <FDBox minWidth={160} maxWidth={isMobile ? undefined : 240} width={'100%'}>
            <FDPrimaryActionButton
              label={primaryActionLabel}
              onClick={handleOnNext}
              loading={loading}
              disabled={disabled || !onNext}
              isFullWidth
              {...dataAttrs('continue-btn')}
            />
          </FDBox>
        </div>
        { clickableTextRel
          ? <ClickableTextRel
            overrideOnClick={handleOnClickableTextRel}
            relationship={clickableTextRel}
            appearance={'standalone'}
            {...dataAttrs('relationship-btn')}
          /> : null
        }
      </FDStack>
    </FDBox>
  );
};
export { RoadmapDeliverableFooterNav };
